// extracted by mini-css-extract-plugin
export default {"sidebarContanier":"PlayerProfileSidebar_sidebarContanier__8cUhQ","disclosed":"PlayerProfileSidebar_disclosed__1suNC","discloseBtn":"PlayerProfileSidebar_discloseBtn__YFUXK"};